export const MOBILE_BREAKPOINT = 'md'

export const PRIVACY_POLICY_URL = 'https://www.goose.pet/privacy-policy'
export const TOS_URL = 'https://www.goose.pet/terms-conditions'
